import { render, staticRenderFns } from "./SalariePrintCardEmpYear.vue?vue&type=template&id=0252a77a&scoped=true"
import script from "./SalariePrintCardEmpYear.vue?vue&type=script&lang=js"
export * from "./SalariePrintCardEmpYear.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintCardEmpYear.vue?vue&type=style&index=0&id=0252a77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0252a77a",
  null
  
)

export default component.exports